import { Link } from "react-router-dom";
import { genres } from "@/mocks/comics";

export default function GenreSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-sm font-medium text-primary-600 tracking-widest">GENRE</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            题材分类
          </h2>
        </div>
        <Link
          to="/category"
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {genres.map((g) => (
          <Link
            key={g.id}
            to={`/category?genre=${g.id}`}
            className="group relative rounded-xl overflow-hidden aspect-[4/3] bg-background-100"
          >
            <img
              src={g.cover}
              alt={`${g.name}题材漫画专区`}
              title={`${g.name}题材漫画`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/75 via-background-950/10 to-transparent"></div>
            <div className="absolute bottom-0 inset-x-0 p-4 md:p-5">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-heart-fill"></i>
                </span>
                <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl">{g.name}番</h3>
              </div>
              <p className="mt-2 text-background-100/85 text-xs md:text-sm leading-relaxed">{g.desc}</p>
              <p className="mt-2 text-accent-200 text-xs">
                <i className="ri-book-3-line mr-1"></i>
                {g.count} 部作品 · 持续更新
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}